import styles from "./folderTestCaseTemplates.module.scss";
import arrowIcon from "../../../shared/images/arrow.svg";
import folderIcon from "../../../shared/images/folder.svg";
import { Popup } from "../../../shared/components/popup/popup";
import editIcon from "../../../shared/images/edit.svg";
import deleteIcon from "../../../shared/images/delete.svg";
import { useTranslation } from "react-i18next";
import { Folder } from "../../../types/testCaseTemplateFolderTypes";
import {
  useEffect,
  useRef,
  useState
} from "react";
import { ReactComponent as MenuIcon } from "../../../shared/images/menu.svg";
import { ReactComponent as AddIcon } from "../../../shared/images/add.svg";
import { MessageWindow } from "../../../shared/components/messageWindow/messageWindow";
import { useDeleteFolderMutation } from "../../../api/testCaseTemplateFolderService";
import { setUpdateModal } from "../../../store/slices/mainSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";

type FolderTestCaseTemplatesProps = {
  folder: Folder;
  onClick: () => void;
  refetch: () => void;
  onEditClick: () => void;
  onAddTemplateClick: () => void;
  arrowClass: string;
}

export const FolderTestCaseTemplates = ({ folder, onClick, refetch, onEditClick, onAddTemplateClick, arrowClass }: FolderTestCaseTemplatesProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();

  const menuContainer = useRef<HTMLDivElement>(null);

  const [showPopup, setShowPopup] = useState<boolean>(false);
  const [showMenu, setShowMenu] = useState<boolean>(false);

  const [showDeleteMessage, setShowDeleteMessage] = useState<boolean>(false)

  const [deleteFolderMutation, { isSuccess: isSuccessDeleteFolder }] = useDeleteFolderMutation();

  useEffect(() => {
    if (isSuccessDeleteFolder) {
      refetch();
      dispatch(setUpdateModal({ show: true, isDelete: true }))
    }
  }, [isSuccessDeleteFolder]);

  const onClickMenuIcon = (): void => {
    setShowPopup(!showPopup);
  }

  const closeMenu = (): void => {
    setShowPopup(false);
  }

  const editClick = (): void => {
    setShowPopup(false);
    onEditClick();
  }

  const addTemplateClick = (): void => {
    setShowPopup(false);
    onAddTemplateClick();
  }

  const deleteClick = (): void => {
    setShowPopup(false);
    setShowDeleteMessage(true);
  }

  const closeMessageWindow = (isConfirm: boolean): void => {
    if (isConfirm) {
      deleteFolderMutation(folder.id as number);
    }
    setShowDeleteMessage(false);
  }

  const deleteFolderDescription = (): string => {
    return t("testCaseTemplate.deleteFolderDescription").replace("{{folderName}}", folder?.name || "");
  }

  return (
    <>
      <div className={`${styles.container} ${showMenu ? styles.hover : ""}`}
           onClick={onClick}
           onMouseEnter={() => setShowMenu(true)}
           onMouseLeave={() => setShowMenu(false)}>
        <div className={styles.info}>
          <div className={styles.arrowContainer}>
            {!(folder.templatesCount === 0) &&
              (<img src={arrowIcon} alt=""
                    className={arrowClass}/>)
            }
          </div>
          <img src={folderIcon} alt=""/>
          <div className={styles.name}>
            <span title={folder.name}>{folder.name}</span>
          </div>
        </div>
      </div>
      { (showMenu || showPopup) && (
        <div className={styles.actions}
             onMouseEnter={() => setShowMenu(true)}
             onMouseLeave={() => setShowMenu(false)}>
          <div className={styles.menu} ref={menuContainer}>
            <div className={styles.menuIcon}
                 onClick={onClickMenuIcon}>
              <MenuIcon/>
            </div>
            <Popup isShow={showPopup}
                   classContainer={styles.popup}
                   left={-70}
                   top={5}
                   parent={menuContainer.current}
                   onClose={closeMenu}
                   child={
                     <>
                       <div className={styles.item}
                            onClick={addTemplateClick}>
                         <AddIcon/>
                         {t("testCaseTemplate.addTemplate")}
                       </div>
                       <div className={styles.item}
                            onClick={editClick}>
                         <img src={editIcon} alt=""/>
                         {t("common.edit")}
                       </div>
                       <div className={styles.item}
                            onClick={deleteClick}>
                         <img src={deleteIcon} alt=""/>
                         {t("common.delete")}
                       </div>
                     </>
                   }
            />
          </div>
        </div>
      ) }
      {showDeleteMessage && (
        <MessageWindow onClose={closeMessageWindow}
                       title={t("testCaseTemplate.deleteFolder")}
                       description={deleteFolderDescription()}
                       primaryText={t("common.ok")} secondaryText={t("common.cancel")}/>
      )}
    </>
  );
}